module.exports = __webpack_public_path__ + "b02cb0bd68269a17f6dcba395f380ac6.pdf";